import React, { FC } from 'react';

import { Image } from '../Image/Image';

import { ArticleSetOfTextWithHeader } from '../ArticleSetOfTextWithHeader';

import { Text } from '../Text/Text';

import { Form } from '../Form';

import { Video } from '../Video/Video';

import * as styles from './ImageWithTextRightLeft.module.scss';
import { ImageWithTextRightLeftProps } from './ImageWithTextRightLeft.types';

export const ImageWithTextRightLeft: FC<ImageWithTextRightLeftProps> = ({
    elements,
    title,
    darkTheme,
    layout,
    alignment,
}: ImageWithTextRightLeftProps) => {
    const getSizeOfContainer = (type?: string, i?: number) => {
        if (type === '1-1' || type === null) {
            return 'Normal';
        } else if (type === '2-1') {
            if (i === 0) {
                return 'Huge';
            } else {
                return 'Small';
            }
        } else if (type === '1-2') {
            if (i === 0) {
                return 'Small';
            } else {
                return 'Huge';
            }
        }
    };

    return (
        <div className={styles.container}>
            {title && (
                <div className={darkTheme ? styles.titleDarkTheme : styles.title}>
                    <Text weight="regular" variant="heading3" tag="p">
                        {title}
                    </Text>
                </div>
            )}
            <div className={alignment === 'top' ? styles.containerImageDescTop : styles.containerImageDesc}>
                {elements?.map((el, i) => {
                    if (el.__typename === 'ContentfulArticleImage') {
                        if (el.image.file.contentType.startsWith('video')) {
                            return (
                                <div className={styles.videoContainer}>
                                    <Video
                                        url={el.image.file.url}
                                        autoplay={true}
                                        fullHeight={true}
                                        loop={true}
                                        controls={false}
                                    />
                                </div>
                            );
                        }

                        return (
                            <Image
                                key={i}
                                image={el.image}
                                wrapperTag={'div'}
                                classWrapper={styles[`imageCointainer${getSizeOfContainer(layout, i)}`]}
                            />
                        );
                    } else if (el.__typename === 'ContentfulGenericSetOfTextWithHeader') {
                        return (
                            <React.Fragment key={i}>
                                <div className={styles[`descContainer${getSizeOfContainer(layout, i)}`]}>
                                    <ArticleSetOfTextWithHeader
                                        bulletType={el.bulletType}
                                        iconTitleColumn={true}
                                        darkTheme={el.darkTheme}
                                        texts={el.texts}
                                        elements={el.elements}
                                        blackColorIcon={true}
                                        titleSize="heading3"
                                        underlineLinksOnHover={false}
                                    />
                                </div>
                            </React.Fragment>
                        );
                    } else {
                        return (
                            <div className={styles[`descContainer${getSizeOfContainer(layout, i)}`]} key={i}>
                                <Form {...el} isImageRightLeftParent={true} aligment={alignment} />
                            </div>
                        );
                    }
                })}
            </div>
        </div>
    );
};
